export default __webpack_public_path__ + "static/media/login-bg.4f230dc9.png";